import { deepGet, deepSet } from 'jsdeep';
export class StorageStore {
    constructor(name, storage) {
        this.name = name;
        this.storage = storage;
    }
    put(key, value) {
        const stringified = JSON.stringify(value);
        this.storage.setItem(key, stringified);
    }
    putDeep(key, path, value) {
        const chunks = this.toChunks(path);
        if (chunks.length === 0) {
            this.put(key, value);
            return;
        }
        const json = this.storage.getItem(key);
        const rootObject = json ? JSON.parse(json) : {};
        const updated = deepSet(rootObject, chunks, value);
        const stringified = JSON.stringify(updated);
        this.storage.setItem(key, stringified);
    }
    getString(key, defaultValue = null) {
        return this.getStringDeep(key, '', defaultValue);
    }
    getStringDeep(key, path, defaultValue = null) {
        return this.getAndParse(key, path, defaultValue, (v) => {
            const parsed = Number.parseInt(v, 10);
            return Number.isNaN(parsed)
                ? defaultValue
                : parsed;
        });
    }
    get(key, defaultValue = null) {
        return this.getStringDeep(key, '', defaultValue);
    }
    getDeep(key, path, defaultValue = null) {
        return this.getAndParse(key, path, defaultValue, (v) => JSON.parse(v));
    }
    getInt(key, defaultValue = null) {
        return this.getIntDeep(key, '', defaultValue);
    }
    getIntDeep(key, path, defaultValue = null) {
        return this.getAndParse(key, path, defaultValue, (v) => {
            const parsed = Number.parseInt(v, 10);
            return Number.isNaN(parsed)
                ? defaultValue
                : parsed;
        });
    }
    getFloat(key, defaultValue = null) {
        return this.getFloatDeep(key, '', defaultValue);
    }
    getFloatDeep(key, path, defaultValue = null) {
        return this.getAndParse(key, path, defaultValue, (v) => {
            const parsed = Number.parseFloat(v);
            return Number.isNaN(parsed)
                ? defaultValue
                : parsed;
        });
    }
    getDate(key, defaultValue = null) {
        return this.getDateDeep(key, '', defaultValue);
    }
    getDateDeep(key, path, defaultValue = null) {
        return this.getAndParse(key, path, defaultValue, (v) => {
            const parsed = new Date(v);
            return Number.isNaN(parsed.getTime())
                ? defaultValue
                : parsed;
        });
    }
    getAndParse(key, path, defaultValue = null, map) {
        const chunks = this.toChunks(path);
        const rawValue = this.storage.getItem(key);
        if (rawValue === null)
            return defaultValue;
        try {
            const rootObject = JSON.parse(rawValue);
            return chunks.length > 0
                ? map(deepGet(rootObject, chunks))
                : rootObject;
        }
        catch (e) {
            const pathMsgPart = path ? `and path ${path}` : '';
            // tslint:disable-next-line
            console.log(`Could not parse ${name} storage value for key "${key}" ${pathMsgPart}:`, rawValue, e);
            this.storage.removeItem(key);
            return defaultValue;
        }
    }
    toChunks(path) {
        if (!path)
            return [];
        return path.split('.')
            .map(i => i.trim())
            .filter(i => i.length > 0);
    }
}
export class Store {
    constructor(localStorage, sessionStorage) {
        this.local = new StorageStore('local', localStorage);
        this.session = new StorageStore('session', sessionStorage);
    }
    static fromWindow(win = window) {
        return new Store(win.localStorage, win.sessionStorage);
    }
}
